// extracted by mini-css-extract-plugin
module.exports = {"BackDrop":"BackDrop-nLUyP","fadeBackDrop":"fadeBackDrop-3g1VH","BackDropUnderNavbar":"BackDropUnderNavbar-9tt2T"};